import React from 'react';

type Props = {
  children: any | Array<any>;
};

const FullAccessWorkbook = ({ children }: Props) => <div>{children}</div>;

export default FullAccessWorkbook;
